import * as React from 'react';
import { observer } from 'mobx-react';
import { Option } from '@payscale/design';
import './managerCard.scss';

export interface IBaseManagerCardProps {
    onCardClick: () => void;
    onCheckboxClick: () => void;
    isManagerSelected: boolean;
    currentReviewer: string;
}

export class BaseManagerCard extends React.Component<IBaseManagerCardProps> {
    constructor(props: IBaseManagerCardProps) {
        super(props);

        this.handleEventPropagation = this.handleEventPropagation.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    render(): React.ReactNode {
        const { onCardClick, onCheckboxClick, isManagerSelected, currentReviewer, children } = this.props;
        return (
            <div
                className={this.managerCardClasses}
                onClick={onCardClick}
                onKeyPress={this.handleKeyPress}
                role="button"
                tabIndex={0}
            >
                <div
                    className="manager-list-card-check"
                    onClick={this.handleEventPropagation}
                    onKeyPress={this.handleEventPropagation}
                    role="presentation"
                >
                    <Option
                        type="checklist"
                        className="pxl-option--secondary manager-list-card-check__checkbox"
                        checked={isManagerSelected}
                        onChange={onCheckboxClick}
                    />
                </div>
                <div>
                    {children}
                    <p className="current-reviewer">
                        Current Reviewer: <span className="current-reviewer__name">{currentReviewer}</span>
                    </p>
                </div>
            </div>
        );
    }

    private get managerCardClasses(): string {
        const { isManagerSelected } = this.props;
        return `nomst-manager-list-card ${isManagerSelected ? 'manager-selected' : ''}`;
    }

    private handleKeyPress(e: React.KeyboardEvent<HTMLDivElement>): void {
        if (e.key === 'Enter') {
            this.props.onCardClick();
        }
    }

    private handleEventPropagation(event: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement>): void {
        event.stopPropagation();
    }
}

export default observer(BaseManagerCard);